import React, { useState, useEffect, useMemo, useCallback } from 'react';
import MaterialGrid from '@material-ui/core/Grid';
import { Box, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FORM_RULES } from 'helpers/validations';
import { Field, Form, reduxForm, getFormValues } from 'redux-form';
import { InputLabelOutlined } from 'common/components/fields/fields';
import { handleWhiteSpaces } from 'helpers/dataTransformers';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import { createTextMask } from 'redux-form-input-masks';
import { getUserAddress, createCreditCard, initializeForm } from './userActionSubscriptionsActions';
import { FullButton } from 'common/components/buttons/fullButton';

let CreditCardSubscription = function ({
  valid,
  reset,
  formValues,
  handleSubmit,
  getUserAddress,
  createCreditCard,
  userActionSubscription,
}) {
  const [focus, setFocus] = useState('');

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  // Função para buscar o endereço com base no CEP
  const handleGetAdress = useCallback(
    (cep) => {
      // console.log('CEP digitado:', cep);
      if (cep && cep.length === 8) {
        const zipcode = { zipcode: cep };
        getUserAddress(zipcode, formValues);
      }
    },
    [formValues, getUserAddress]
  );

  // Criando as máscaras com useMemo
  const cepMask = useMemo(
    () =>
      createTextMask({
        pattern: '99.999-999',
        stripMask: true,
        onChange: (updatedValue) => handleGetAdress(updatedValue),
      }),
    [handleGetAdress]
  );

  const cpfMask = useMemo(
    () =>
      createTextMask({
        pattern: '999.999.999-99',
        stripMask: true,
      }),
    []
  );

  const dateMask = useMemo(
    () => createTextMask({
      pattern: '99/99/9999',
      stripMask: true,
    }),
    []
  );

  const phoneMask = useMemo(
    () => createTextMask({
      pattern: '(99) 9 9999-9999',
      stripMask: true,
    }),
    []
  );

  const dateReducedMask = useMemo(
    () =>
      createTextMask({
        pattern: '99/99',
        stripMask: true,
      }),
    []
  );

  const creditCardMask = useMemo(
    () =>
      createTextMask({
        pattern: '9999 9999 9999 9999',
        stripMask: true,
      }),
    []
  );

  const handleInputFocus = useCallback((e) => {
    // console.log('Evento onFocus:', e.target.name); // Debug
    const name = e.target.name ? e.target.name.split('.')[1] : '';
    if (name) {
      setFocus(name);
    }
  }, []);

  const onSubmit = (formValues) => {
    console.log('Valores do formulário:', formValues);
    createCreditCard(formValues, reset);
  };

  return (
    <section
      id="extract"
      style={{ backgroundColor: 'transparent', minHeight: '100vh' }}
    >
      <Typography variant="h4">
        Cadastrar novo cartão
      </Typography>
      <Box style={{ margin: 24 }}>
        <Cards
          cvc={formValues?.payment?.cvv || ''}
          expiry={formValues?.payment?.expiry || ''}
          focused={focus}
          name={formValues?.payment?.name || ''}
          number={formValues?.payment?.number || ''}
        />
      </Box>
      <div className="py-4">
        <Form
          noValidate
          onSubmit={handleSubmit(onSubmit)}
          style={{
            backgroundColor: 'transparent',
            height: '75vh',
          }}
        >
          <MaterialGrid container spacing={3} style={{ padding: '0px 24px' }}>
            <MaterialGrid
              item
              md={12}
              lg={6}
              style={{ padding: '12px 6px 12px 0' }}
            >
              <Box>
                <Typography
                  variant="h6"
                  style={{ color: '#707070', marginBottom: 8 }}
                >
                  Dados do cartão
                </Typography>
              </Box>
              <Box style={{ marginTop: 12 }}>
                <Field
                  component={InputLabelOutlined}
                  label="Número do cartão"
                  type="tel"
                  name={`payment.number`}
                  normalize={handleWhiteSpaces}
                  inputProps={{
                    maxLength: 19,
                  }}
                  validate={[FORM_RULES.required, FORM_RULES.card_number]}
                  onFocus={handleInputFocus}
                  {...creditCardMask}
                />
              </Box>
              <Box style={{ marginTop: 12 }}>
                <Field
                  component={InputLabelOutlined}
                  label="Nome escrito no cartão"
                  type="text"
                  name={`payment.name`}
                  validate={[FORM_RULES.required]}
                  onFocus={handleInputFocus}
                />
              </Box>
              <Box style={{ marginTop: 12 }}>
                <Field
                  component={InputLabelOutlined}
                  label="CPF do dono do cartão"
                  type="text"
                  name={`payment.cpf`}
                  validate={[FORM_RULES.required, FORM_RULES.cpf]}
                  onFocus={handleInputFocus}
                  {...cpfMask}
                />
              </Box>
              <Box style={{ marginTop: 12 }}>
                <Field
                  component={InputLabelOutlined}
                  label="Data de Nascimento"
                  type="tel"
                  name="payment.birthday"
                  validate={[FORM_RULES.required]}
                  {...dateMask}
                />
              </Box>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                style={{ marginTop: 12 }}
              >
                <Box style={{ marginRight: 6, flex: 1 }}>
                  <Field
                    component={InputLabelOutlined}
                    label="Expiração"
                    type="tel"
                    name={`payment.expiry`}
                    validate={[
                      FORM_RULES.required,
                      FORM_RULES.expiry,
                      FORM_RULES.max(4),
                    ]}
                    onFocus={handleInputFocus}
                    {...dateReducedMask}
                  />
                </Box>
                <Box style={{ marginLeft: 6, flex: 1 }}>
                  <Field
                    component={InputLabelOutlined}
                    label="CVC"
                    type="tel"
                    name={`payment.cvv`}
                    inputProps={{
                      maxLength: 3,
                    }}
                    validate={[
                      FORM_RULES.required,
                      FORM_RULES.cvc,
                      FORM_RULES.max(3),
                    ]}
                    onFocus={handleInputFocus}
                  />
                </Box>
              </Box>
            </MaterialGrid>
            <MaterialGrid
              item
              md={12}
              lg={6}
              style={{ padding: '12px 0px 12px 6px' }}
            >
              <Box>
                <Typography
                  variant="h6"
                  style={{ color: '#707070', marginBottom: 8 }}
                >
                  Endereço de cobrança
                </Typography>
              </Box>
              <Box style={{ marginTop: 12 }}>
                <Field
                  component={InputLabelOutlined}
                  label="Telefone"
                  type="tel"
                  inputlabelprops={{
                    shrink: true,
                  }}
                  name="payment.phone"
                  validate={[FORM_RULES.required]}
                  {...phoneMask}
                />
              </Box>
              <Box style={{ marginTop: 12 }}>
                <Field
                  component={InputLabelOutlined}
                  label="CEP"
                  type="tel"
                  name={`payment.cep`}
                  validate={[FORM_RULES.required]}
                  {...cepMask}
                />
              </Box>
              <Box style={{ marginTop: 12 }}>
                <Field
                  component={InputLabelOutlined}
                  label="Rua"
                  type="text"
                  name={`payment.street`}
                  validate={[FORM_RULES.required]}
                />
              </Box>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                style={{ marginTop: 12 }}
              >
                <Box style={{ flex: 1 }}>
                  <Field
                    component={InputLabelOutlined}
                    label="Cidade"
                    type="text"
                    name={`payment.city`}
                    validate={[FORM_RULES.required]}
                  />
                </Box>
                <Box style={{ flex: 1, marginLeft: 12 }}>
                  <Field
                    component={InputLabelOutlined}
                    label="Estado (UF)"
                    type="text"
                    name={`payment.state`}
                    validate={[FORM_RULES.required]}
                  />
                </Box>
              </Box>
              <Box style={{ marginTop: 12 }}>
                <Field
                  component={InputLabelOutlined}
                  label="Número"
                  type="tel"
                  name={`payment.street_number`}
                  validate={[FORM_RULES.required]}
                />
              </Box>
            </MaterialGrid>
            <MaterialGrid
              item
              container
              justifyContent="flex-end"
              alignItems="flex-end"
              xs={12}
              style={{ padding: '12px 0px', borderTop: '1px solid rgb(131 131 131 / 23%)'}}
            >
              <MaterialGrid item xs={2}>
                <FullButton
                  classNameProp="py-3 px-4"
                  type="submit"
                  disabled={!valid || userActionSubscription.loading}
                  style={{ height: 56, minWidth: '100%' }}
                >
                  { !userActionSubscription.loading ? 'Salvar' : 'Salvando' }
                </FullButton>
              </MaterialGrid>
            </MaterialGrid>
          </MaterialGrid>
        </Form>
      </div>
    </section>
  );
};

CreditCardSubscription = reduxForm({
  form: 'creditCardSubscriptionActionForm',
  destroyOnUnmount: true,
})(CreditCardSubscription);

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    userActionSubscription: state.userActionSubscriptions,
    formValues: getFormValues('creditCardSubscriptionActionForm')(state) || {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getUserAddress,
    createCreditCard,
    initializeForm,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CreditCardSubscription);
